export var getParams = function (params) {
    if (!params)
        return undefined;
    var cleared = {};
    Object.keys(params).forEach(function (key) {
        if (params[key] || params[key] === 0)
            cleared[key] = params[key];
    });
    return cleared;
};
//# sourceMappingURL=getParams.js.map